<template>
    <div class="approvalTitleRule">
        <div class="choose-enterprise-body">
            <el-container class="container-body">
                <el-form style="width: 100%;" label-position="right" size="mini" label-width="130px">
                    <el-form-item  label="实例命名规则">
                        <div class="form-data-link-config">
                            <el-row>
                                <div class="process-data-link-config-opera">
                                    <el-button type="primary" @click="addTitleRuleLink">新增规则组合条件</el-button>
                                </div>
                            </el-row>
                            <el-row v-for="(obj,index) in titleRuleBOs" :key="index">
                                <el-col :span="6">
                                    <el-form-item label="类型" :span="6">
                                        <el-select v-model="obj.titleType" placeholder="请选择类型" class="triggerSource" @change="changeTitleType(obj)">
                                            <el-option
                                                v-for="item in titleTypeList"
                                                :key="item.key"
                                                :label="item.value"
                                                :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col v-if="obj.titleType===2" :span="6">
                                    <el-form-item label="当前表单">
                                        <el-select v-model="obj.formId" placeholder="请选择任务表单" class="triggerSource" @change="changeForm(obj)">
                                            <el-option
                                                v-for="item in forms"
                                                :key="item.id"
                                                :label="item.formName"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col v-if="obj.titleType===2" :span="6" >
                                    <el-form-item label="表单字段">
                                        <el-select v-model="obj.titleValue" placeholder="请选择字段" class="triggerSource" @change="changeFormField(obj)">
                                            <el-option
                                                v-for="item in obj.formFieldIdList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" >
                                    <div class="opear-delete"><i class="el-icon-delete" @click="deleteTitleRuleLink(obj)"></i></div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-form-item>
                </el-form>
            </el-container>
        </div>
        <div class="choose-enterprise-btn">
            <el-button type="info" @click="cancelClick">取消</el-button>
            <el-button type="primary" @click="confirmClick">保存</el-button>
        </div>
    </div>
</template>

<script>
    import { cloneDeep } from 'lodash';

    export default{
        data () {
            return {
                titleTypeList: [
                    {
                        key: 0,
                        value: '模板名称'
                    },
                    {
                        key: 1,
                        value: '时间戳'
                    },
                    {
                        key: 2,
                        value: '表单字段'
                    }
                ],
                titleRuleBOs: []
            };
        },
        props: {
            templateInfo: {
                type: Object
            },
            forms: {// 审批流表单
                type: Array,
                default: []
            }
        },
        created () {
            // console.log(this.forms);
            this._initPage();
        },
        methods: {
            async _initPage () {
                if (this.templateInfo) {
                    this.titleRuleBOs = this.templateInfo.titleRuleBOs;
                    this.dealFormApprovalList();
                }
            },
            async dealFormApprovalList () {
                if (this.titleRuleBOs && this.titleRuleBOs.length > 0) {
                    this.titleRuleBOs.forEach(async item => {
                        // 初始化每一项的formFieldIdList，用于反显
                        item.formFieldIdList = [];
                        for (let i = 0; i < this.forms.length; i++) {
                            let obj = this.forms[i];
                            if (obj.id === item.formId) {
                                if (obj.fieldsList) {
                                    obj.fieldsList.forEach(field => {
                                        if (field.type !== 'file' && field.type !== 'subform' && field.type !== 'divider') {
                                            item.formFieldIdList.push(field);
                                        }
                                    });
                                }
                            }
                        }
                    });
                }
            },
            addTitleRuleLink () {
                let item = {
                    id: this.generateUUID(),
                    approvalTemplateId: this.templateInfo.id,
                    titleType: 0,
                    formId: '',
                    titleValue: '',
                    formFieldIdList: []
                };
                this.titleRuleBOs.push(item); // list尾部新增
            },
            deleteTitleRuleLink (e) {
                for (let i = 0; i < this.titleRuleBOs.length; i++) {
                    let cur = this.titleRuleBOs[i];
                    if (cur.id === e.id) {
                        this.titleRuleBOs.splice(i, 1);
                    }
                }
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            },
            changeTitleType (e) {
                console.log(e);
            },
            changeForm (e) {
                if (e) {
                    e.formFieldIdList = [];
                    for (let i = 0; i < this.forms.length; i++) {
                        let obj = this.forms[i];
                        if (obj.id === e.formId) {
                            obj.fieldsList.forEach(field => {
                                if (field.type !== 'file' && field.type !== 'subform' && field.type !== 'divider') {
                                    e.formFieldIdList.push(field);
                                }
                            });
                        }
                    }
                }
            },
            changeFormField (e) {
                if (e) {
                    for (let i = 0; i < e.formFieldIdList.length; i++) {
                        let obj = e.formFieldIdList[i];
                        if (obj.id === e.titleValue) {
                            e.fieldType = obj.type;
                            break;
                        }
                    }
                }
            },
            confirmClick () {
                this.$emit('confirmClick', this.titleRuleBOs);
            },
            cancelClick () {
                this.$emit('cancelClick');
            }
        }
    };
</script>

<style lang="less">
    .approvalTitleRule{
        .choose-enterprise-body{
            .container-body {
                width: 100%;
                height: 365px;
                .el-header {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .el-main {
                    padding: 0;
                }
        
                .el-aside {
                    border-right: 1px solid #dcdfe6;
                }
            }
        }
        .choose-enterprise-btn{
            text-align: right;
            padding-right: 20px;
            position: relative;
            top: 20px;
            margin: 10px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ApprovalTitleRule/ApprovalTitleRule.vue